export default Object.freeze({
  MOTOR_MANUAL_POSITION: { min: 0, max: 100 },

  //Basic Settings
  MILD_WEATHER_DAY: { min: 50.0, max: 120.0 },
  MILD_WEATHER_NIGHT: { min: 50.0, max: 120.0 },
  VALVE_FEEDBACK_SENSITIVITY: { min: 1, max: 100 },
  EXPONENTIAL_SENSITIVITY: { min: 0, max: 100 },
  EXPONENTIAL_CURVE: { min: 0, max: 100 },
  //Motor Settings
  VALVE_SET_SPEED: { min: 1, max: 10 },
  //Heat Balancer Settings
  HEAT_BALANCER_FEEDBACK_SENSITIVITY: { min: 1, max: 10 },
  //AHA
  RAMP_UP_SPEED: { min: 1, max: 10 },
  RAMP_DOWN_SPEED: { min: 1, max: 10 },
  HEATUP_ADJUSTMENT: { min: -100, max: 100 },
  MIDDAY_ADJUSTMENT: { min: -100, max: 100 },
  NIGH_ADJUSTMENT: { min: -100, max: 100 },
  //Compensator
  COMPENSATOR: { min: -50, max: 50 },
  COMPENSATOR_SENSITIVITY: { min: 1, max: 50 },
  //Return Line
  RETURN_LINE_SETPOINT: { min: 50.0, max: 180 },
  RETURN_LINE_DEADBAND: { min: 1, max: 10 },
  RETURN_LINE_VALVE_ADJUSTMENT: { min: -90, max: -1 },
  //Differential
  DIFFERENTIAL_SETPOINT: { min: 0, max: 40 },
  DIFFERENTIAL_DEADBAND: { min: 0.1, max: 20 },
  //Temperature Sensors
  TEMPERATURE_SENSORS_CALIBRATION_ADJUSTMENT: { min: -100, max: 100 },
  TEMPERATURE_SENSORS_RANGE_HIGH: { min: 0, max: 1000 },
  TEMPERATURE_SENSORS_RANGE_LOW: { min: -1000, max: 1000 },
  //Pressure Sensors
  PRESSURE_SENSORS_CALIBRATION_ADJUSTMENT: { min: -100, max: 100 },
  PRESSURE_SENSORS_RANGE_HIGH: { min: 0, max: 1000 },
  PRESSURE_SENSORS_RANGE_LOW: { min: -1000, max: 1000 }
});



// WEBPACK FOOTER //
// ./src/common/constants/system.js